import { Tab, TabProps } from '@mui/material'
import { FC } from 'react'
import { Link, LinkProps } from 'react-router-dom'

type LinkTabProps = TabProps & Pick<LinkProps, 'to'>

/**
 * A wrapper over MUI's `Tab` component that internally uses `react-router-dom`'s Link for navigation.
 */
export const LinkTab: FC<LinkTabProps> = props => {
  const { to, ...tabProps } = props
  return <Tab component={Link} to={to} {...tabProps} />
}
